<template>
  <div class="footer">
    {{ $t('global.page.footerText') }}
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class FooterComponent extends Vue {

}
</script>

<style lang="scss" scoped>
.footer {
  padding: $content-padding;
  font-weight: $font-weight-light;
  margin-top: 30px;
}
</style>